import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const cmpConsentTokenCacheKey = 'cmpConsentToken';
export const cmpConsentTokenDocument = /* GraphQL */ `
    query CmpConsentToken {
        cmpConsentToken {
            success
            token
            errorCode
        }
    }
`;
export const cmpConsentTokenQuery = graphql(cmpConsentTokenDocument);
